/* eslint-disable no-unused-vars */
import { useState, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { cellWidth, campaignReportsDefaultSelectedCols } from 'constants';
import { Pen } from 'assets/icons';
import { IconButton, CustomTooltip } from 'components';
import { Bid } from './Bid';
import * as S from './RightSideRow.styled';

function getTruncetedNumber(num) {
  if (!num) return 0;
  return Number(num).toLocaleString('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
}

export const RightSideRow = ({ data, isUa }) => {
  const allColls = campaignReportsDefaultSelectedCols.cols.map((col) => col.colName);
  const selectedCols = useSelector((state) => state.campaignReports.selectedCols);
  const selectedEvents = useSelector((state) => state.campaignReports.selectedEvents);
  const currentRequestType = useSelector((state) => state.campaignReports.tableRequestTypes);

  const eventsToDisplay = getFilteredEvents(selectedEvents, data);

  function calcPercentageOfEvents(eventValue) {
    let value;

    if (data.bid_type == 2) {
      value = isUa ? data.Installs : data.Clicks; // CPC
    } else {
      value = data.Installs; // CPI, CPM
    }

    return calcPercentage(eventValue, value);
  }
  const selectedTableItems = useSelector((state) => state.campaignReports.selectedTableItems);

  const isChecked = selectedTableItems.findIndex(
    ({ pba_number }) => pba_number === data.pba_number,
  );

  return (
    <>
      {currentRequestType === 'Apps' && (
        <Bid selectedCols={selectedCols} data={data} cellWidth={cellWidth} />
      )}
      {selectedCols.map((cellName, ind) => (
        <S.Cell
          key={cellName}
          style={{
            width: cellWidth[cellName] || cellWidth.base,
            marginRight: ind === selectedCols.length - 1 ? '8px' : 0,
          }}
        >
          <S.CellInner style={{ width: cellWidth[cellName] || cellWidth.base }}>
            {formateValue(data[cellName], cellName)}
          </S.CellInner>
        </S.Cell>
      ))}
      {eventsToDisplay?.events?.length > 0 && (
        <>
          <S.EventWrap>
            {eventsToDisplay.events.map((event, ind) => (
              <S.EventCell key={data.event_id_arr[ind] + ind} style={{ width: cellWidth.event }}>
                <div>{getTruncetedNumber(event)}</div>
                {!!eventsToDisplay.pubAmountPerEventCountArr[ind] && (
                  <div>
                    {getTruncetedNumber(eventsToDisplay.pubAmountPerEventCountArr[ind])}{' '}
                    {data.pubAmountCurrency || ''}
                  </div>
                )}
                <div>{calcPercentageOfEvents(event)}%</div>
                <div>${calcCPAOfEvents(event, data.Cost)}</div>
              </S.EventCell>
            ))}
          </S.EventWrap>
          <S.EventWrap>
            {eventsToDisplay.eventsCohort.map((event, ind) => (
              <S.EventCell
                key={data.event_id_arr[ind] + 'cohort'}
                style={{ width: cellWidth.event }}
              >
                <div>{getTruncetedNumber(event)}</div>
                {!!eventsToDisplay.pubAmountPerEventCountArrCohort[ind] && (
                  <div>
                    {getTruncetedNumber(eventsToDisplay.pubAmountPerEventCountArrCohort[ind])}{' '}
                    {data.pubAmountCurrency || ''}
                  </div>
                )}
                <div>{calcPercentageOfEvents(event)}%</div>
                <div>${calcCPAOfEvents(event, data.Cost)}</div>
              </S.EventCell>
            ))}
          </S.EventWrap>
        </>
      )}
    </>
  );
};

function getFilteredEvents(selectedEvents, data) {
  let eventsToDisplay = {
    events: [],
    eventsCohort: [],
    pubAmountPerEventCountArr: [],
    pubAmountPerEventCountArrCohort: [],
  };

  selectedEvents.forEach((item) => {
    if (item.isSelected) {
      const dataIndex = data?.event_id_arr.indexOf(item.eventId);

      if (dataIndex !== -1) {
        eventsToDisplay.events.unshift(data.eventCountArr[dataIndex]);
        eventsToDisplay.eventsCohort.unshift(data.eventCountArrCohort[dataIndex]);

        eventsToDisplay.pubAmountPerEventCountArr.unshift(
          data.pubAmountPerEventCountArr[dataIndex],
        );
        eventsToDisplay.pubAmountPerEventCountArrCohort.unshift(
          data.pubAmountPerEventCountArrCohort[dataIndex],
        );
      }
    }
  });

  return eventsToDisplay;
}

function formateValue(val, metric) {
  if (!val) val = 0;

  let pref = '';
  let suf = '';

  if (metric === 'Cost' || metric === 'AvgCpi' || metric === 'eCPM') pref = '$';
  if (metric === 'CR' || metric === 'CTR') suf = '%';

  const minfractionDigits = metric === 'Cost' && !!val ? 2 : metric === 'eCPM' ? 3 : 0;
  const maxfractionDigits = metric === 'eCPM' ? 3 : 2;

  const formattedNumber = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: minfractionDigits,
    maximumFractionDigits: maxfractionDigits,
  }).format(+val);

  return pref + formattedNumber + suf;
}

function calcCPAOfEvents(eventValue, cost) {
  const cpa = eventValue ? cost / eventValue : 0;
  return +cpa.toFixed(2);
}

function calcPercentage(n1, n2) {
  return n2 === 0 ? '0' : ((n1 / n2) * 100).toFixed(0);
}
